/*
 * Gets unit defintions as downloaded via fetchInitial
 */
import type { RootState } from '/business/shared/state/store';
import type { UnitData } from '/business/shared/state/selectors/types';

const DEFAULT_UNIT_DATA: UnitData = {
  fetching: false,
  fetchedForApplicationId: null,
  saving: false,
  saved: false,
  fetched: false,
  error: null,
  collection: [],
  loadErrorApplicationId: null,
};

export default (state: RootState): UnitData => state.unitData || DEFAULT_UNIT_DATA;
